import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let zhizairouter = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home/index.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/product/index.vue'),
      children: [
        {
          name: 'DigitalTwinPlatform',
          path: 'DigitalTwinPlatform',
          component: () => import('./views/product/DigitalTwinPlatform.vue'),
        },
        {
          name: 'BIMApplication',
          path: 'BIMApplication',
          component: () => import('./views/product/BIMApplication.vue'),
        },
        {
          name: 'housingConstruction',
          path: 'housingConstruction',
          component: () => import('./views/product/housingConstruction.vue'),
        },
      ],
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/service/index.vue'),
      children: [
        {
          name: 'GISData',
          path: 'GISData',
          component: () => import('./views/service/GISData.vue'),
        },
        {
          name: 'droneService',
          path: 'droneService',
          component: () => import('./views/service/droneService.vue'),
        },
        {
          name: 'BIMConsult',
          path: 'BIMConsult',
          component: () => import('./views/service/BIMConsult.vue'),
        },
        {
          name: 'sceneExperience',
          path: 'sceneExperience',
          component: () => import('./views/service/sceneExperience.vue'),
        },
      ],
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('./views/solution/index.vue'),
      children: [
        {
          name: 'CIMBasicPlatform',
          path: 'CIMBasicPlatform',
          component: () => import('./views/solution/CIMBasicPlatform.vue'),
        },
        {
          name: 'BIMSupervision',
          path: 'BIMSupervision',
          component: () => import('./views/solution/BIMSupervision.vue'),
        },
        { name: 'HouseSecurity', path: 'HouseSecurity', component: () => import('./views/solution/HouseSecurity.vue') },
        {
          name: 'estateMonitoring',
          path: 'estateMonitoring',
          component: () => import('./views/solution/estateMonitoring.vue'),
        },
        { name: 'publicHousing', path: 'publicHousing', component: () => import('./views/solution/publicHousing.vue') },
        {
          name: 'SmartAgriculture',
          path: 'SmartAgriculture',
          component: () => import('./views/solution/SmartAgriculture.vue'),
        },
        {
          name: 'FarmHouseSupervision',
          path: 'FarmHouseSupervision',
          component: () => import('./views/solution/FarmHouseSupervision.vue'),
        },
        { name: 'ruralService', path: 'ruralService', component: () => import('./views/solution/ruralService.vue') },
        {
          name: 'SmartLawEnforcement',
          path: 'SmartLawEnforcement',
          component: () => import('./views/solution/SmartLawEnforcement.vue'),
        },
        {
          name: 'SmartMunicipal',
          path: 'SmartMunicipal',
          component: () => import('./views/solution/SmartMunicipal.vue'),
        },
        {
          name: 'SmartTransportation',
          path: 'SmartTransportation',
          component: () => import('./views/solution/SmartTransportation.vue'),
        },
        {
          name: 'SmartIndustrialPark',
          path: 'SmartIndustrialPark',
          component: () => import('./views/solution/SmartIndustrialPark.vue'),
        },
        { name: 'SmartCampus', path: 'SmartCampus', component: () => import('./views/solution/SmartCampus.vue') },
        { name: 'oldHouse', path: 'oldHouse', component: () => import('./views/solution/oldHouse.vue') },
        { name: 'realEstate', path: 'realEstate', component: () => import('./views/solution/realEstate.vue') },
      ],
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: () => import('./views/introduce/index.vue'),
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('./views/aboutUs/index.vue'),
    },
  ],
})

// // 判断是否需要登录权限 以及是否登录
// zhizairouter.beforeEach((to, from, next) => {
//   // 判断是否需要登录权限
//   if (to.matched.some(res => res.meta.requireAuth)) {
//     // 判断是否登录
//     if (sessionStorage.getItem('token')) {
//       next()
//     } else {
//       // 没登录则跳转到登录界面
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath,
//         },
//       })
//     }
//   } else {
//     next()
//   }
// })

export default zhizairouter
